// 영구 수정 #34 (D-036) — 조직도 무결성 강제 validator.
// destructive RC API call 을 클라이언트 단에서 차단. 서버 차단보다 fail-fast.
// 운영 시 RC custom service / proxy 에서도 같은 차단 (defense in depth).

// 차단 대상 — 항상 비활성/archive 대안 사용.
const BLOCKED_ENDPOINTS: Array<{ pattern: RegExp; alt: string; reason: string }> = [
	// 사용자 영구 삭제 X — users.setActiveStatus active=false 만 허용
	{ pattern: /\/api\/v1\/users\.delete(\?|$)/, alt: '/api/v1/users.setActiveStatus { activeStatus: false }', reason: '영구 수정 #34: 사용자 영구 삭제 금지. 비활성화만.' },
	{ pattern: /\/api\/v1\/users\.deleteOwnAccount(\?|$)/, alt: '/api/v1/users.setActiveStatus', reason: '영구 수정 #34: 본인 계정 삭제 금지 (메시지 보존). 비활성화.' },

	// 채널/룸 영구 삭제 X — archive 사용
	{ pattern: /\/api\/v1\/channels\.delete(\?|$)/, alt: '/api/v1/channels.archive', reason: '영구 수정 #34: 채널 영구 삭제 금지. archive 사용.' },
	{ pattern: /\/api\/v1\/groups\.delete(\?|$)/, alt: '/api/v1/groups.archive', reason: '영구 수정 #34: 비공개 채널 영구 삭제 금지. archive 사용.' },
	{ pattern: /\/api\/v1\/rooms\.cleanHistory(\?|$)/, alt: '없음 (메시지 영구 보존)', reason: '영구 수정 #34: 메시지 영구 보존. cleanHistory 차단.' },
	// im.close 차단 해제 (2026-06-05) — DM 닫기는 "나가기"일 뿐 메시지는 서버에 보존됨. 사용자 요청으로 허용.

	// 메시지 영구 삭제 — 옵션: hideMessage 또는 admin only 로 제한
	// (chat.delete 는 기본 허용 — RC 자체에서 retention policy 처리)
];

// 안전한 대안 매핑 — 호출자에게 redirect hint
export interface BlockedCallInfo {
	blocked: true;
	endpoint: string;
	alt: string;
	reason: string;
}

export function checkSafety(url: string): BlockedCallInfo | null {
	for (const { pattern, alt, reason } of BLOCKED_ENDPOINTS) {
		if (pattern.test(url)) {
			return { blocked: true, endpoint: url, alt, reason };
		}
	}
	return null;
}

// 글로벌 fetch 인터셉터 — main.tsx 에서 1회 init 호출.
// destructive endpoint 호출 시 throw + 콘솔 경고 + 텔레메트리 (window event).
let installed = false;

export function installSafetyValidator(): void {
	if (installed) return;
	installed = true;
	const original = window.fetch.bind(window);
	window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
		const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
		const method = (init?.method || (input instanceof Request ? input.method : 'GET') || 'GET').toUpperCase();
		// 안전한 GET 은 통과 (조회만)
		if (method === 'GET' || method === 'HEAD') return original(input, init);
		const check = checkSafety(url);
		if (check) {
			const err = new Error(`[안전 정책 차단 #34] ${check.reason}\n대안: ${check.alt}\n원본 endpoint: ${check.endpoint}`);
			// telemetry 이벤트 — admin 대시보드 audit log 에 노출 가능
			try {
				window.dispatchEvent(new CustomEvent('tpt:safety-block', { detail: check }));
			} catch { /* ignore */ }
			console.warn('[#34 SAFETY BLOCK]', check);
			return Promise.reject(err);
		}
		return original(input, init);
	}) as typeof window.fetch;
}
